import { Button } from "@/components/ui/button";
import { Pencil, Trash2, Image as ImageIcon } from "lucide-react";

interface Post {
  id: string;
  title: string;
  content: string;
  image_url?: string;
}

interface PostItemProps {
  post: Post;
  onEdit: (post: Post) => void;
  onDelete: (id: string) => void;
}

export const PostItem = ({ post, onEdit, onDelete }: PostItemProps) => {
  return (
    <div className="flex items-start justify-between p-4 bg-background rounded-lg border">
      <div className="space-y-1">
        <h3 className="font-medium">{post.title}</h3>
        <p className="text-sm text-muted-foreground">{post.content}</p>
        {post.image_url && (
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <ImageIcon className="h-4 w-4" />
            <span>Imagen adjunta</span>
          </div>
        )}
      </div>
      <div className="flex items-center gap-2">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => onEdit(post)}
        >
          <Pencil className="h-4 w-4" />
        </Button>
        <Button
          variant="ghost"
          size="icon"
          onClick={() => onDelete(post.id)}
        >
          <Trash2 className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};